import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SellingCompetitor')
export class SellingCompetitor {
  @JsonProperty('sellerId', String, true) sellerId: string = undefined;
  @JsonProperty('sellerName', String, true) sellerName: string = undefined;
  @JsonProperty('isAmazon', Boolean, true) isAmazon = false;
  @JsonProperty('id', String, true) id: string = undefined;
}
